/** Legacy entry used for AFFiNE ESM module compat */
export { ContentParser } from './_legacy/content-parser/index.js';
